const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* PaintMySoul homepage hero: keep autoplay timing continuous regardless of mouse hover. */
document.addEventListener(
  'mouseenter',
  (event) => {
    const target = event.target;
    if (target instanceof Element && target.matches('paintmysoul-hero-slideshow')) {
      event.stopImmediatePropagation();
    }
  },
  true
);

document.addEventListener(
  'mouseleave',
  (event) => {
    const target = event.target;
    if (target instanceof Element && target.matches('paintmysoul-hero-slideshow')) {
      event.stopImmediatePropagation();
    }
  },
  true
);
